<ng-container *cxFeature="'a11yAnonymousConsentMessageInDialog'">
  <div class="cx-dialog-message" aria-live="assertive" aria-atomic="true">
    <cx-message
      *ngIf="message$ | async as message"
      [text]="message.key | cxTranslate"
      [type]="message.type"
      [isVisibleCloseButton]="true"
      (closeMessage)="closeMessage()"
      [cxFocus]="{ autofocus: '.cx-message' }"
    ></cx-message>
  </div>
</ng-container>

<div
  class="modal-dialog modal-dialog-centered modal-lg cx-anonymous-consent-dialog"
  role="dialog"
  [cxFocus]="focusConfig"
  (esc)="close('Escape clicked')"
  aria-labelledby="dialogTitle"
>
  <div class="modal-content cx-dialog-content">
    <div *ngIf="loading$ | async; else dialogBody">
      <cx-spinner></cx-spinner>
    </div>

    <ng-template #dialogBody>
      <div class="modal-header cx-dialog-header">
        <h3 id="dialogTitle">
          {{ 'anonymousConsents.dialog.title' | cxTranslate }}
        </h3>
        <button
          type="button"
          class="close"
          title="{{ 'common.close' | cxTranslate }}"
          [attr.aria-label]="'common.close' | cxTranslate"
          (click)="close('Cross click')"
        >
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>

      <h4 class="cookies-paragraph" [innerHTML]="'cookies.paragraph1' | cxTranslate"></h4>

      <div class="cx-dialog-buttons">
        <button class="btn-outline btn-accept" (click)="rejectAll()">
          {{ 'cookies.reject' | cxTranslate }}
        </button>
        <button class="btn-outline btn-accept" (click)="allowAll()">
          {{ 'cookies.accept' | cxTranslate }}
        </button>
      </div>

      <div class="modal-body cx-dialog-body" *ngIf="templates$ | async as templates">
        <ng-container *ngIf="consents$ | async as consents">
          <div class="cx-dialog-row col-sm-12 col-md-6" *ngFor="let template of templates">
            <cx-consent-management-form
              [consentTemplate]="template"
              [requiredConsents]="requiredConsents"
              [consent]="getCorrespondingConsent(template, consents)"
              (consentChanged)="onConsentChange($event)"
            ></cx-consent-management-form>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </div>
</div>
